<template>
  <div class="home">
    <div class="grid">
      <figure class="effect-sadie">
        <img src="../assets/weather.jpg" />
        <figcaption>
          <h2>Méteo</h2>
          <router-link to="/meteo">Méteo</router-link>
        </figcaption>
      </figure>
      <figure class="effect-sadie">
        <img src="../assets/calculator.jpg" />
        <figcaption>
          <h2>Calculatrice</h2>
          <router-link to="/calcul">Calculatrice</router-link>
        </figcaption>
      </figure>
      <figure class="effect-sadie">
        <img src="../assets/todo.jpg" />
        <figcaption>
          <h2>To-Do</h2>
          <router-link to="/todo">To-Do</router-link>
        </figcaption>
      </figure>
      <figure class="effect-sadie">
        <img src="../assets/sort.jpg" />
        <figcaption>
          <h2>Sorting</h2>
          <router-link to="/sort">Sort</router-link>
        </figcaption>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>
<style scoped>
.home {
  min-height: 90vh;
  width: 100vw;
  background: url("../assets/bg.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.grid {
  display: grid;
  min-height: 80%;
  width: 80%;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  align-items: center;
  justify-content: center;
}

/* Common style */
.grid figure {
  position: relative;
  justify-self: center;
  overflow: hidden;
  margin: 10px 1%;
  min-width: 320px;
  max-width: 480px;
  height: 250px;
  width: 48%;
  background: #3085a3;
  text-align: center;
  cursor: pointer;
}

.grid figure img {
  position: relative;
  display: block;
  object-fit: cover;
  min-height: 100%;
  max-width: 100%;
  opacity: 0.8;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.grid figure figcaption > a {
  z-index: 700;
  text-indent: 200%;
  white-space: nowrap;
  font-size: 0;
  opacity: 0;
}

.grid figure h2 {
  word-spacing: -0.15em;
  font-weight: 800;
}

.grid figure h2 {
  margin: 0;
}

figure.effect-sadie figcaption::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: -webkit-linear-gradient(
    top,
    rgba(72, 76, 97, 0) 0%,
    rgba(72, 76, 97, 0.8) 75%
  );
  background: linear-gradient(
    to bottom,
    rgba(72, 76, 97, 0) 0%,
    rgba(72, 76, 97, 0.8) 75%
  );
  content: "";
  opacity: 0;
  -webkit-transform: translate3d(0, 50%, 0);
  transform: translate3d(0, 50%, 0);
}

figure.effect-sadie h2 {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  color: #484c61;
  -webkit-transition: -webkit-transform 0.35s, color 0.35s;
  transition: transform 0.35s, color 0.35s;
  -webkit-transform: translate3d(0, -50%, 0);
  transform: translate3d(0, -50%, 0);
}

figure.effect-sadie figcaption::before {
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
}

figure.effect-sadie:hover h2 {
  color: #fff;
  -webkit-transform: translate3d(0, -50%, 0) translate3d(0, -40px, 0);
  transform: translate3d(0, -50%, 0) translate3d(0, -40px, 0);
}

figure.effect-sadie:hover figcaption::before {
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
</style>